export default __webpack_public_path__ + "static/assets/1c15c7cc0992ae0a0092f15047eb54d5.svg";